var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('Table',{attrs:{"result":_vm.result,"get-data":_vm.getCareer},on:{"filterCareer":_vm.getFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }